import { atomWithReset as stateSegmentWithReset } from 'jotai/utils';
import {
  EmailModule,
  RequestParams,
  ContextItem,
} from '../../../types/userSessionContext';

export const contextStateSegment = stateSegmentWithReset<{
  requestPayload: RequestParams | null;
  selectedEmailModules: EmailModule[] | null;
  sessionContext: ContextItem[] | null;
  documentInfo: {
    title: string;
    documentType: string;
    customerType: string;
  } | null;
  error: boolean;
  loading: boolean;
  isContextValid: boolean;
  errorMessage: string;
}>({
  requestPayload: null,
  selectedEmailModules: null,
  sessionContext: null,
  documentInfo: null,
  error: false,
  loading: false,
  isContextValid: false,
  errorMessage: '',
});

contextStateSegment.debugLabel = 'contextStateSegment';
